import PreSignalLatest from 'components/Insights/Pre-signal-latest';
import {
	FXSLeftColLayout,
	TwoColsMainLayout
} from 'components/Layouts';
import UserNoPremium from 'components/UserNoPremium';
import { PRE_SIGNAL_QUERY } from 'constants/queryParams';
import { useTranslationsContext } from 'contexts/translationsContext';
import { PremiumProps } from 'models/props';
import { FXS_hd_med_padding_left } from 'styles/typography';
import { getQueryParam } from 'utils/getQueryParam';
import { useIsLessThan } from 'fxs-utils';

export default function PreSignalInfo({ isPremium }: PremiumProps) {
	const { t } = useTranslationsContext();
	const isLessThan1280 = useIsLessThan(1280);
	const isLessThan833 = useIsLessThan(833);

	const preOrderTitle = getQueryParam(PRE_SIGNAL_QUERY);

	return (
		<TwoColsMainLayout>
			{!isPremium && <UserNoPremium />}
			<FXSLeftColLayout
				id='fxs_signals_messaging_bar_inner'
				isLessThan1280={isLessThan1280}
				isLessThan833={isLessThan833}
				removePaddings={true}
				removeScroll={true}
				removeBg={true}
				isInsights={true}
			>
				<FXS_hd_med_padding_left>
					{preOrderTitle}
					{t('preOrderInfoTitle')}
				</FXS_hd_med_padding_left>
				{isPremium && <PreSignalLatest />}
			</FXSLeftColLayout>
		</TwoColsMainLayout>
	);
}
